import { useState, useEffect } from 'react';
import {  useNavigate } from 'react-router-dom';
import { fetchIpdRelease, fetchIpdVoucher, podtApproval } from './ipdReleaseService';
import { errorToast, successToast } from '../../../components/toastmessage/toastmessage';


function useIpdReleaseHook() {
    const [ipdReleaseListState, setIpdReleaseListState] = useState([]);
    const [selectIpd, setSelectedIpd] = useState("");
    const [filterSelectedIpd, setFilterSelectedIpd] = useState([]);
    const [voucherSelectedIpd, setVoucherSelectedIpd] = useState([]);
    const [sumAmount, setSumAmount] = useState(0);
    const [finalAmount, setFinalAmount] = useState(0);
    const [remarks, setReamrks] = useState("");
    const [discount, setDiscount] = useState("");

    const navigate = useNavigate();



    const fetchIpdReleaseList = async () => {
        try {
            let result = await fetchIpdRelease();
            if (result.status === 200) setIpdReleaseListState(result?.data?.result);
        } catch (e) {
            return e
        }

    }


    useEffect(() => {
        fetchIpdReleaseList();

    }, []);
    const handleSelectIpd = async (e, ipdList) => {
        e.preventDefault();
        if (e?.target.value) {
            setSelectedIpd(e?.target.value)
            let filteredVal = ipdList?.filter((ele) => ele.ipdid === e?.target.value);
            setFilterSelectedIpd(filteredVal)
            let response = await fetchIpdVoucher(e?.target.value);
            if (response.status) {
                returnSumAmount(response?.data?.result)
                setVoucherSelectedIpd(response?.data?.result)

            }


        }

    }
    const returnSumAmount = (voucherList) => {
        const sum = voucherList?.reduce(function (prev, cur) {
            return prev + cur?.amount;
        }, 0);
        setSumAmount(sum)

    }

    function calculateDiscount(e) {
        setDiscount(e.target.value)
        if (e.target.value >=sumAmount) {
            errorToast("Invalid Amount Entered")
            // Check for invalid input values
            return "Invalid input";
        }
        // Calculate the discounted price
        // const discountAmount = (sumAmount * Number(e.target.value)) / 100;
        const discountedPrice = sumAmount - Number(e.target.value);
        setFinalAmount(discountedPrice)
    };


    const handleApprove = async () => {
        if (!remarks) {
            errorToast("Remarks Is Required")
            return;
        }
        const payload = {
            billAmount: sumAmount,
            discountAmount: discount.trim() === "" ? 0 : (sumAmount - finalAmount),
            finalAmount: finalAmount ? finalAmount : sumAmount,
            remarks: remarks,
            ipdId: selectIpd
        }
        try {
            let res = await podtApproval(selectIpd, payload)
            if (res?.status) successToast("Successfully Inserted");
            navigate("/ipd")


        } catch (e) {
            errorToast(e?.response?.data?.message)
        }


    }

    return {
        ipdReleaseListState,
        handleSelectIpd,
        selectIpd,
        filterSelectedIpd,
        voucherSelectedIpd,
        returnSumAmount,
        sumAmount,
        handleApprove,
        calculateDiscount,
        finalAmount,
        setReamrks,
        discount

    };
}

export default useIpdReleaseHook;
